export default __webpack_public_path__ + "static/pop-ai-6a83653352383b7d43064173b3142ecc.png";